import { isValidUrl } from '@omnea-app/packages/universal/general/isValidUrl'

export const getURLFromString = (website: string): URL | null => {
  if (!isValidUrl(website)) {
    return null
  }
  try {
    const protocol = website.startsWith('http') ? '' : 'https://'
    return new URL(`${protocol}${website}`)
  } catch (error) {
    console.info(error)
    return null
  }
}
